import { combineReducers } from '@reduxjs/toolkit'
import entitiesReducer from './entities/entity'

export default combineReducers({
  entities: entitiesReducer,
})
